import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { enUS, rsHLV } from "./locales";

const resources = {
  en: enUS,
  rs: rsHLV,
};

i18n.use(initReactI18next).init({
  resources,
  lng: "rs",
  fallbackLng: "rs",

  interpolation: {
    escapeValue: false,
  },
});
